<template>
    <ModalTitle
        :model-value="props.modelValue"
        @update:model-value="fnModalValueChanged"
        :backdrop="false"
        container-class="w-[690px] max-w-[95vw]"
    >
        <template #header>
            <h1 class="" style="line-height: 40px;"> 
                {{ $t('waves.fairnessTitleOnHeader') }}
            </h1>
        </template>
        <!-- ↑标题 -->
        <!-- ↓主体 -->
        <section class="mainbox body" >
            <div class="body__inner fair">
                <div class="fair__desc">
                    {{ $t('waves.fairDesc01') }}
                </div>
                <HashBar 
                    :title="$t('HashRound')"
                    :hash="'789789789789789123asdf789789789789789123asdf789789789789789123asdf789789789789789123asdf'"
                />
                <section class="fair__section fair__section--dropdown">
                    <h2 class="fair__title">
                        {{ $t('waves.fairnessTitleInside') }}
                    </h2>
                    <q-select
                        class="time-selector"
                        filled 
                        standout
                        v-model="model"
                        :options="options"
                        popup-content-class="option-box_48r65965u4825d2d"
                    />
                    <HashBar
                        :title="$t('RoundSeed')"
                        :hash="'789789789789789123asdf789789789789789123asdf789789789789789123asdf789789789789789123asdf'"
                    />
                    <HashBar
                        :title="$t('HashRound')"
                        :hash="'789789789789789123asdf789789789789789123asdf789789789789789123asdf789789789789789123asdf'"
                    />
                </section>
                <section class="fair__section">
                    <h4 class="fair__title">
                        {{ $t('waves.fiarPart01Title') }}
                    </h4>
                    <p class="fair__desc">
                        {{ $t('waves.fiarPart01Desc01') }}
                    </p>
                    <p class="fair__desc">
                        {{ $t('waves.fiarPart01Desc02') }}
                    </p>
                    <p class="fair__desc">
                        {{ $t('waves.fiarPart01Desc03') }}
                    </p>
                </section>
                <section class="fair__section">
                    <h4 class="fair__title">
                        {{ $t('waves.fiarPart02Title') }}
                    </h4>
                    <p class="fair__desc">
                        {{ $t('waves.fiarPart02Desc01') }}
                    </p>
                    <p class="fair__desc fair__desc--together">
                        {{ $t('waves.fiarPart02Desc02') }}
                    </p>
                    <p class="fair__desc fair__desc--together">
                        {{ $t('waves.fiarPart02Desc03') }}
                    </p>
                        <div class="fair__code-wrap">
                            <code class="fair__code">
                                const { Decimal } = require('decimal.js'); <br />
                                const ss = require('simple-statistics'); <br />
                                const crypto = require('node:crypto'); <br />
                                <br />

                                let price = new Decimal(1000.0); <br />
                                <br />
                                // Replace the seed with the one that matches the round you want to
                                verify <br />
                                const
                                seed='4cd5043b4c9dfdb77910cf7b5bc3952117426ba87fb1eff8b0289b8056baa202';
                                <br />
                                const volatility = 0.001; <br />
                                <br />

                                function convertToUnsignedInt(seed) { <br />
                                &nbsp; const combinedValue = Buffer.from(seed, 'ascii'); <br />
                                &nbsp; const hex =
                                crypto.createHash('sha256').update(combinedValue).digest('hex');
                                <br />
                                &nbsp; const first8Bytes = Buffer.from(hex.substring(0, 16), 'hex');
                                <br />
                                &nbsp; let unsignedInt = new Decimal(0); <br />
                                &nbsp; for (let i = 7; i &gt;= 0; i--) { <br />
                                &nbsp; &nbsp; unsignedInt =
                                unsignedInt.times(256).plus(first8Bytes[i]); <br />
                                &nbsp; } <br />
                                &nbsp; return unsignedInt; <br />
                                } <br />
                                <br />

                                console.log(`tick: 0 price: ${price}`); <br />
                                <br />

                                // Replace the number “5” with the number of the tick whose price you
                                want to verify <br />
                                for (let tick = 1; tick &lt;= 5; tick++) { <br />
                                &nbsp; const unsignedInt = convertToUnsignedInt(seed + tick); <br />
                                &nbsp; const unitRangeFloat = unsignedInt.dividedBy(new
                                Decimal(2).pow(64).minus(1)); <br />
                                &nbsp; const normalReturn = ss.probit(unitRangeFloat.toNumber()) *
                                volatility; <br />
                                &nbsp; price = price.times(1 + normalReturn); <br />
                                &nbsp; console.log(`tick: ${tick} price: ${price.toFixed(2)}`); <br />
                                } <br />
                                process.exit(0);
                            </code>
                        </div>
                    <p class="fair__desc fair__desc--sub-title">
                        {{ $t('waves.fiarOutput') }} 
                    </p>
                    <div class="fair__code-wrap">
                        <code class="fair__code">
                            "tick: 0 price: 1000"<br />
                            "tick: 1 price: 999.89"<br />
                            "tick: 2 price: 1000.58"<br />
                            "tick: 3 price: 1000.75"<br />
                            "tick: 4 price: 999.90"<br />
                            "tick: 5 price: 1000.16"
                        </code>
                    </div>
                </section>
            </div>
        </section>
        <!-- ◆分界 -->
        <template #footer>
            <div class="footer-box" >
                <ButtonThe3DButton 
                    class="footer-button"
                    color="blue" size="lg"
                    v-click-and-rest
                    @click="onClickHowItWorks"
                >
                    {{$t('HowItWorks')}}
                </ButtonThe3DButton>
                <ButtonThe3DButton 
                    class="footer-button"
                    color="red" size="lg"
                    v-click-and-rest
                    @click="onClickCheck"
                >
                    {{$t('Check')}}
                </ButtonThe3DButton>
            </div>
        </template>
    </ModalTitle>
</template>


<script lang="ts" setup>
import HashBar from './hashBar.vue';
import 'quasar/src/components/select/QSelect.sass'; 

const props = defineComponent({
    modelValue: {
        type: Boolean, // 管控可见性 
        default: false,
    },
});
const hashRound123 = ref('112233445566asdfasdfasdf112233445566asdfasdfasdf112233445566asdfasdfasdf');
const model = ref('Facebook');
const options = [
    'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
];

const emits = defineEmits(['update:modelValue']);

function fnModalValueChanged(newVal){
    emits('update:modelValue', !!newVal);
}

const onClickHowItWorks = () => {
    emits('update:modelValue', false);
    useNavigator('fairness')
}

const onClickCheck = () => {
    const sCheckPage = 'https://www.movable-type.co.uk/scripts/sha256.html';
    window.open(sCheckPage, '_blank');
}

</script>


<style scoped lang="scss">
// ↓ 自制类名 
.mainbox{
    max-height: calc(100vh - 64px - 73px - 100px);
    overflow-y: auto;
    margin-inline: -24px;
    padding: 0 24px;
}
.footer-box{
    width: 100%; 
    display: flex;
    justify-content: space-between;
    .footer-button{
        margin-left: 0 !important; 
        width: calc(50% - 6px);
    }
}
.hash-row{
    .hash-box-title{ 
        font-size: 14px;
        padding: 0;
        color: #54647D;
        font-size: "Montserrat Variable", sans-serif; 
    }
    :deep(.hash-input) {
        padding: 1.5rem 0.5rem 0.5rem;
    }
    
}

// =============

.fairoFairness {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px
}

.fair__titleoFairness {
    color: var(--color_white);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 20px;
    margin-bottom: 8px;
    margin-top: 0
}

.fair__descoFairness {
    color: #a7b5ca;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 0
}

.fair__descoFairness:not(:first-of-type) {
    margin-top: 8px
}

.fair__desc--togetheroFairness:not(:first-of-type) {
    margin-top: 0
}

.fair__desc--sub-titleoFairness:not(:first-of-type) {
    margin-top: 16px
}

.fair__code-wrapoFairness {
    background: var(--Dark-Shades-Gray-100,#1c2532);
    border: 1px solid hsla(0,0%,100%,.04);
    border-radius: 8px;
    margin-top: 8px;
    padding: 10px 12px;
}

.fair__codeoFairness {
    color: #a7b5ca;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 16px;
    margin-bottom: 0;
    margin-top: 0
}

.fair__section--dropdownoFairness {
    display: flex;
    flex-direction: column;
    gap: 8px
}

.fair__section--dropdown .fair__titleoFairness {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -.02em;
    line-height: 32px;
    margin-bottom: 0;
    margin-top: 0
}

.fair__no-infooFairness {
    align-items: center;
    color: #a7b5ca;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    height: 124px;
    justify-content: center;
    line-height: 20px;
    margin-bottom: 0
}

.fairoFairness .input-copy-new .input__tag {
    margin-top: 0
}

.fairoFairness .input-copy-new .h7 {
    margin-bottom: 0
}

.footeroFairness {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2,1fr)
}

// ===================
// ===================
// ===================

.fair {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px
}

.fair__title {
    color: var(--color_white);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 20px;
    margin-bottom: 8px;
    margin-top: 0
}

.fair__desc {
    color: #a7b5ca;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 0
}

.fair__desc:not(:first-of-type) {
    margin-top: 8px
}

.fair__desc--together:not(:first-of-type) {
    margin-top: 0
}

.fair__desc--sub-title:not(:first-of-type) {
    margin-top: 16px
}

.fair__code-wrap {
    background: var(--Dark-Shades-Gray-100,#1c2532);
    border: 1px solid hsla(0,0%,100%,.04);
    border-radius: 8px;
    margin-top: 8px;
    padding: 10px 12px
}

.fair__code {
    color: #a7b5ca;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 16px;
    margin-bottom: 0;
    margin-top: 0;
    // ↓ 补 ----------------------
    white-space: normal;
    word-break: break-all;
}

.fair__section--dropdown {
    display: flex;
    flex-direction: column;
    gap: 8px
}

.fair__section--dropdown .fair__title {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -.02em;
    line-height: 32px;
    margin-bottom: 0;
    margin-top: 0
}

.fair__no-info {
    align-items: center;
    color: #a7b5ca;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    height: 124px;
    justify-content: center;
    line-height: 20px;
    margin-bottom: 0
}

.fair .input-copy-new .input__tag {
    margin-top: 0
}

.fair .input-copy-new .h7 {
    margin-bottom: 0
}

.footer {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2,1fr)
}

// ============================
// ===== ↓ input =======================
// ============================
.time-selector{
    &:deep(){
        .q-field__native{
            color: white;
            font-weight: 600;
            // line-height: 18px;
            white-space: nowrap;
        }
        .q-field__control{
            background: #1D2837;
            border-radius: 10px;
            &:after{
                display: none !important;
            }
        }
        .q-select__dropdown-icon{
            color: var(--color_grey-20);
        }
    }
}
</style>

<!-- ↓ 无 scoped 全局样式 -->
<style lang="scss">
body > *[id*=q-portal--menu--] .option-box_48r65965u4825d2d{
    .q-item__label{
        color: white;
    }
}
</style>
